import React from 'react';
import PropTypes from 'prop-types';
import styled from 'styled-components';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faTimes } from '@fortawesome/free-solid-svg-icons/faTimes';

const DismissButton = styled.button`
  border: none;
  background-color: transparent;
  position: absolute;
  top: 0px;
  right: 0px;
  padding: ${({ theme }) => theme.spacing * 2}px;
`;

const StyledMessage = styled.div`
  position: relative;
  padding: ${({ theme }) => theme.spacing * 2}px;
  padding-right: ${({ theme }) => theme.spacing * 8}px;
  line-height: 1.4;

  ${({ type = 'info', theme }) => `
    background-color: ${theme.palette.messages[type].background};
    color: ${theme.palette.messages[type].contrastText};
    ${DismissButton} {
      color: ${theme.palette.messages[type].contrastText};
    }
  `}
`;

const Message = ({
  type, message, nonDismissable, onDismiss,
}) => (
  <StyledMessage type={type}>
    {message}
    {!nonDismissable && (
      <DismissButton onClick={onDismiss}>
        <FontAwesomeIcon icon={faTimes} />
      </DismissButton>
    )}
  </StyledMessage>
);

Message.displayName = 'Message';

Message.propTypes = {
  type: PropTypes.oneOf(['info', 'warning', 'error']).isRequired,
  message: PropTypes.node.isRequired,
  nonDismissable: PropTypes.bool,
  onDismiss: PropTypes.func,
};

Message.defaultProps = {
  nonDismissable: false,
  onDismiss: null,
};

export default Message;
